module.exports = __webpack_public_path__ + "img/yc-bg1-btn.f09a6775.png";